import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Container extends Vue {
    currentActiveImageIndex = 0;

    currentActiveImageIndexUpdate(index: number): void
    {
        this.currentActiveImageIndex = index;
    }

    get mainContainerClasses(): any
    {
        return {
            'main-container': true,
            'main-container--one': this.currentActiveImageIndex === 0,
            'main-container--two': this.currentActiveImageIndex === 1,
            'main-container--three': this.currentActiveImageIndex === 2,
            'main-container--four': this.currentActiveImageIndex === 3
        }
    }
}
